import 'react';
import { BsImage } from '@react-icons/all-files/bs/BsImage';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Image as Image$1 } from './Image.js';
import { ImageInspector } from './Image.Inspector.js';
import { jsx } from '@emotion/react';

var Image = decorateComponent(Image$1, 'block', {
  id: 'image',
  label: '이미지',
  allowedChildren: ['imageMapLink', 'imageMapShare', 'imageMapBraze'],
  renderIcon: function renderIcon() {
    return jsx(BsImage, null);
  },
  renderInspector: ImageInspector
});

export { Image as default };
//# sourceMappingURL=index.js.map
